import React from 'react';
import { Checkbox } from 'antd';
import './styles.less';

interface TermsAgreementProps {
  checked: boolean;
  onChange: (e: any) => void;
  privacyUrl?: string;
  usageUrl?: string;
  warningText?: string;
}

const prefixCls = 'terms-agreement';

const TermsAgreement: React.FC<TermsAgreementProps> = ({
  checked,
  onChange,
  privacyUrl = 'https://www.ichengzi8.com/terms/privacy_policy',
  usageUrl = 'https://www.ichengzi8.com/terms/usage',
  warningText = '请勾选同意协议后再进行登录'
}) => {
  return (
    <div className="form-footer">
      <div className={`${prefixCls}-checkbox`}>
        <Checkbox
          checked={checked}
          onChange={onChange}
          className={`${prefixCls}-checkbox-input`}
        >
          我已阅读并同意
          <a href={privacyUrl} className="register-link" target="_blank" rel="noreferrer">个人隐私协议</a>
          和
          <a href={usageUrl} className="register-link" target="_blank" rel="noreferrer">账号使用规则</a>
        </Checkbox>
      </div>
      {!checked && (
        <div className={`${prefixCls}-warning`}>
          <span className={`${prefixCls}-warning-text`}>{warningText}</span>
        </div>
      )}
    </div>
  );
};

export default TermsAgreement;

